import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-270efea9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row securities_basic w-100 m-0" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Liability Balance ", -1))
const _hoisted_6 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_7 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Total Paid By Investors ", -1))
const _hoisted_9 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_10 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Total Principle Paid ", -1))
const _hoisted_12 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_13 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Balance ", -1))
const _hoisted_15 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_16 = { class: "row mt-2" }
const _hoisted_17 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Coupon Due ", -1))
const _hoisted_19 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_20 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Total Acquisition ", -1))
const _hoisted_22 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_23 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Not Invested ", -1))
const _hoisted_25 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_26 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Growth* ", -1))
const _hoisted_28 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_29 = { class: "row mt-2" }
const _hoisted_30 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " ROI ", -1))
const _hoisted_32 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_33 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " IRR ", -1))
const _hoisted_35 = { class: "m-0 p-0 myinv_label_white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.liability_balance!=='undefined' ? _ctx.basic.liability_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.investor_paid!=='undefined' ? _ctx.basic.investor_paid.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.principle_paid!=='undefined' ? _ctx.basic.principle_paid.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.balance!=='undefined' ? _ctx.basic.balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.coupon_due!=='undefined' ? _ctx.basic.coupon_due.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.total_acquisition!=='undefined' ? _ctx.basic.total_acquisition.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.not_invested!=='undefined' ? _ctx.basic.not_invested.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.basic.growth), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.basic.roi), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.basic.irr), 1)
        ])
      ])
    ])
  ]))
}